import React from 'react';
import { Table, Tag } from 'antd';
import { ShipmentBatch } from '../../../services/supplyChainService';

interface LogisticsBatchTableProps {
    dataSource: ShipmentBatch[];
    loading: boolean;
}

export const LogisticsBatchTable: React.FC<LogisticsBatchTableProps> = ({ dataSource, loading }) => {
    const columns = [
        { title: 'Batch #', dataIndex: 'batch_number', key: 'batch_number', render: (t: string) => <b>{t}</b> },
        { title: 'Carrier', dataIndex: 'carrier', key: 'carrier' },
        { title: 'Status', dataIndex: 'status', key: 'status', render: (s: string) => <Tag color="blue">{s && s.toUpperCase()}</Tag> },
        { title: 'ETD', dataIndex: 'etd', key: 'etd' },
        { title: 'ETA', dataIndex: 'eta', key: 'eta' },
    ];

    return <Table dataSource={dataSource} columns={columns} rowKey="id" loading={loading} />;
};
